import type { ReactNode } from 'react';

export const symbol_south_east: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M658-260 181-737q-9-9-9-21t9-21q9-9 21-9t21 9l477 477v-264q0-13 8.5-21.5T730-596q13 0 21.5 8.5T760-566v336q0 13-8.5 21.5T730-200H394q-13 0-21.5-8.5T364-230q0-13 8.5-21.5T394-260h264Z"
		/>
	</svg>
);
